;(function () {
  const root =
    (typeof window === "object" && window.self === window && window) ||
    (typeof global === "object" && global.global === global && global) ||
    this ||
    {}
  const util = {
    extend: function (target) {
      for (let i = 1, len = arguments.length; i < len; i++) {
        for (const prop in arguments[i]) {
          if (arguments[i].hasOwnProperty(prop)) {
            target[prop] = arguments[i][prop]
          }
        }
      }
      return target
    },
    setClassName(selector, className) {
      selector.className = className
    },
    addClass(selector, className) {
      selector.classList.add(className)
    },
    setInlineStyle(selector, attr, content) {
      let length = selector.length
      for (let i = 0; i < length; i++) {
        selector[i].style[attr] = content
      }
    },
    isValidListener: function (listener) {
      if (typeof listener === "function") {
        return true
      } else if (listener && typeof listener === "object") {
        return util.isValidListener(listener.listener)
      } else {
        return false
      }
    },
    addCSS: function (cssText) {
      const style = document.createElement("style"), //创建一个style元素
        head = document.head || document.getElementsByTagName("head")[0] //获取head元素
      style.type = "text/css" //这里必须显示设置style元素的type属性为text/css，否则在ie中不起作用
      if (style.styleSheet) {
        //IE
        const func = function () {
          try {
            //防止IE中stylesheet数量超过限制而发生错误
            style.styleSheet.cssText = cssText
          } catch (e) {}
        }
        //如果当前styleSheet还不能用，则放到异步中则行
        if (style.styleSheet.disabled) {
          setTimeout(func, 10)
        } else {
          func()
        }
      } else {
        //w3c
        //w3c浏览器中只要创建文本节点插入到style元素中就行了
        const textNode = document.createTextNode(cssText)
        style.appendChild(textNode)
      }
      head.appendChild(style) //把创建的style元素插入到head中
    },
  }

  function EventEmitter() {
    // handlers是一个map，用于存储事件与回调之间的对应关系
    this.handlers = {}
  }

  EventEmitter.prototype.on = function (eventName, listener) {
    if (!eventName || !listener) return

    // 验证是否为有效回调
    if (!util.isValidListener(listener)) {
      throw new TypeError("listener must be a function")
    }

    const handlers = this.handlers
    // 先检查一下目标事件名有没有对应的监听函数队列
    if (!handlers[eventName]) {
      // 如果没有，那么首先初始化一个监听函数队列
      handlers[eventName] = []
    }
    const listeners = handlers[eventName]

    // 不重复添加事件
    if (listeners.indexOf(listener) === -1) {
      listeners.push(listener)
    }

    return this
  }

  // 为事件注册单次监听器
  EventEmitter.prototype.once = function (eventName, listener) {
    // 对回调函数进行包装，使其执行完毕自动被移除
    const wrapper = (...args) => {
      listener.apply(...args)
      this.off(eventName, wrapper)
    }
    return this.on(eventName, wrapper)
  }

  // 移除某个事件回调队列里的指定回调函数
  EventEmitter.prototype.off = function (eventName, listener) {
    const listeners = this.handlers[eventName]
    if (!listeners) return
    const index = listeners.indexOf(listener)
    if (index !== -1) {
      listeners.splice(index, 1, null)
    }
    return this
  }

  EventEmitter.prototype.emit = function (eventName, ...args) {
    // 检查目标事件是否有监听函数队列
    if (this.handlers[eventName]) {
      // 如果有，则逐个调用队列里的回调函数
      this.handlers[eventName].forEach((callback) => {
        callback(...args)
      })
    }
  }

  function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype)
    subClass.prototype.constructor = subClass
    subClass.__proto__ = superClass
  }

  function SliderTools(options) {
    EventEmitter.call(this)
    this.options = util.extend({}, this.constructor.defaultOptions, options)
    this.init()
    this.bindEvent()
    this.diffX = 0
    this.flag = false
    this.ratio = 0
  }
  // 将EventEmitter原型指向SliderTools
  _inheritsLoose(SliderTools, EventEmitter)

  SliderTools.VERSION = "1.0.0"

  SliderTools.defaultOptions = {
    el: document.body,
  }

  const proto = SliderTools.prototype

  proto.init = function () {
    this.createSlider()
    this.getElements()
  }

  proto.createSlider = function () {
    this.options.el.innerHTML = `
      <div id="slider">
        <div class="drag_bg"></div>
        <div class="drag_text" onselectstart="return false;" unselectable="on">拖动左边滑块完成上方拼图</div>
        <div class="handler handler_bg"></div>
      </div>
      `
    util.addCSS(
      `
        #slider {
          position: relative;
          width: 430px;
          height: 64px;
          text-align: center;
          border-radius: 32px;
          background-color: rgba(232, 232, 232, 1);
          color: #515151;
        }
        #slider .handler {
          position: absolute;
          top: -18px;
          left: 0px;
          width: 100px;
          height: 100px;
          cursor: move;
        }
        .handler_bg {
          background: url("data:image/png;base64,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")
            no-repeat center;
        }
        .handler_ok_bg {
          background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAXkklEQVR4Xu1dCXRURbqu3pd0dzoJQvaELYAEdIgGARlQOCISEGGEcVwgOBpBZXHGARdGFBEc58kyIw46ElGUAQdEiCIeeYJsEg0DJiwCkp1EBZL0vqT7vvN3ujrVt+/a3em047uHe0J3V9Vf9X/1r1V1rwT9/xVXHJDEVW+YO0PvI99nitYM3+e4YkE8AkL2Cf6PbzRx4kTZypWv5uh06j5SqdQglUr1MolMJ5EgPXCVopDZQ3ksXq/X7PV6TRaL4+JTTz1Ru2fPHo+f6wAOvjEQdMC6FaB4AIQRgGXLlilnzry3UKfVjpXJZddJpJI8qUQKQKhlMhmSSCRBdwcgVNDt8XiQ1+t1eCnvRcpLnfO0e05abLb9W7e+V75s2TIXAQ4JSrcC1J2AYNoBKTh69GhmZmb2DIVMPk4ik46Uy+Q6pVJJyWQyCYAAN74AEPICMMgL/w7fAzD+m3K5XJJ2T7uF8niPuD3t+xoa6raNGDGigQGcbgGmOwAJAqK09EP9uLEFdymUyvvkCsUYpUopVcgVEoVC4ZMAsRcJRDBAHZ8ANwDJ7XbDDQB5293uA26Xa/O+/RUfFhffZaaptZgCI37EYjnUWZ4EQnrgwIG0/n3zFsoV8ocUCqVepVIhpVLZKQGE0mdjbPhd6TBMPoAQQi6XCzmdTvhr9rS3v3n++3NrxowZ04QQ8vqL4KKRkBRUNxaABAFx5MiR3Jzs3k/I5fJitVqt1mo0SCKVCupsVxfyer3Ibrcjh8PhaG9vL62tq3515MiRNbEEpisBCQJi1apVCffec/8SlVq1SK1WqzQaNZJI4gMIOtBeikKODmCcTodz9Xtb3l21ZMkSayyA6SpAcLvAcemFCzVFep32f1Qqda5Wq5VI40Qi+CTOJzE2G+VwOmrMFtsf+vXLLfODAqqsS9RYtAEJkoodO3Yk3zR85D9UStVUbYLWZ6h/jhc4ADarjXK6nDu/OnbkkWnTpl3tKmmJJiBBUlFVdbawR0ryZo1GA1IRlscUX+BRyGq1gY2puXzl6n35+QPLu0JaogUICYasrqZuvkaTsEKn1ykUCkWUaNC9zyg1Kxj1DvrgKlvMVrfdbn0mOzd7HUIIsgBRU2HRGBUO7KQjRtyt+Pe2tX9TazRz9DqdRCojjTbpaDJxge93oZxja4evfb7fO+l7PV5ktlgoh92+8TczFjx+9OgHbkKFRRS3RApIAIzFixcnLJi/aJNGo5mi0yVIQoK6kAkukAHh1qPjF247LPUguLRYLJTdbt+1dt3qWS+//DLphYUNSiSABMDYuHFj0sTbJ21Xq9WjdTpdR9DFN1F5GSZUItgiSJ7vo0GfQiAp4B4f3PPpx9PnzJnTEqmkhAtIkGQsXPDEbq1GMzpBl+BLTZAXzn6wfe8LlTkuXstBG0F30LdarMhmtx9cs/bVyZFKSjiABMAoKJis3PXRG1u0Wu0UkAxSMDCP+WSXVZDoPfM3JLS9WNO3WCzIZrPtmnLnw/dUVOyGTDJOu/B1OXgCi1QMmE2QdpXV1zWu1+kSinU6fYB9Ai0Dr0YTNQpiEN1J32IxUxaLtTQrO2Oe3/si12EEsVqMhJCurby6unaBQW9YpdfrQw24INIdhVgEIaQFoYwWQTrq9MHQm81mymxqW5zbJxdc4naxLrFYQMCPlVVUnByemZn5udGgV0qJNQqxzOAq31UACO1juPS9Xg9qbTO7GhoaxhcUXHeMiFMECb1QQLDdkG3YsKHHnVPuOpKYaMiRyyHoYzO7vOZYKG94ysUf/Xa3m2ozmWo/2vXhyJKSkst+UOhLx4zjEgIIaTfkjfWXtuj0+qmQDhHnH9FL8ykrsX4znx8bW/o2mw1ZzOadGVnp9/hVlyB7IhQQn6qqqjo7JS215zaD3iAJUf5Rmu//Nc1QCJnMJqqp+ccZ+fkDdwlVXXyABFTVo48+alj67HPfGAyGXIVCzsC3cLVutCCIP/pudzsymUw1y198/obXXnvNJER1CQEEpENR/X3t80nJSU8mJGj56kTGYWwSupYKex+jTN9qtVEtV1te6d035znITdLS9qzeJFMHsXTId+/e3Wf4jSNOJBoTVVKpQE4JtelCy4mFWWi7QsuFSR8WudraTM5jXx+9fvLkyRf99oTVwHNxF36DAFBRW1u/xphofFir1XR2i8+J47PZuCW2HvAx6mdE326zo5a21jdycrIW+qUEDDzjCNjYEZCOt99+O2vi7ZOqjMZEtTSWa+DxZxLEykigvJfyotbWNseeTz/Onz17dj2XlHAB4pOO6ou1q5KSkuYnsLi5bFntkCRf2MMR51yzJjO7mT64wS0tLet698lZwiUlTIAEpGPevCeTn/vzk+eNiUadxG87wvV3KZqE0tth+52vnlA+87XT1fTBlrS2tZmff+EveevXvwJr8pBWCbElbICAZ6U8U3Xm/l5pqRtwJpd58HwBHLeyx8AIZUhoH34+9CEj/ENTc8mg/EHvwv48Jo+LDkgg7kAIqRrqL+02Go1jlUr+3SJiGUuWd7Rb0asn/oT2tX6AZIkUmpw2Gz2S8SJSSFScAmBvt6LVPPWY+kWnV5Q2G81NfxEppNz0uHNvHazkmlhulxu1tLbuz8xKn4wQcjLFJUyA+OKO0tLS3KJJU6oSDQZZV0flK76ah/a2vY+8aXaEFB37BX6X9Ac0L3UVJyCxridUPbKWoxBqM5k8ZR/vyi8uLoYdkSFxCRMgYMyV585dWNTzmp7LtVqNwMAj/O7euiUdufu0IsrgDuTjdVIj+jTvJ85GY10v/BF21rTZ7NSPP/24NC+v32q/2gpygenMBumAvIiyob5xZ5IxaZxCgLqKtKNjNvdC3oEmROnAznVehwbCBGK/Yl0v0nFC/Q611bIvMytjqh8Qcs0kSBkBOD51NXbsWN3Wf31QYzQmwvaRaPSDs42x7/VCHgAkQRwgsa4XDUbAIlZra5t15m/vzt2/f7+FrrZIbgci8y++ODhmSP7gPQaD76QY9xWF5YguYSxHpB8uPUZGhDF+k8mMKqtOTbzlltEH6DEJHRCfuvruzPln0tJTl6jVagnr+hMfUPTfw2VQuPU46I99n0UiBxAqks+bjmD8DoeDampqXjVgUP8VhNryjZQEBNsPVW1N/fspKclFSkXnARqx9MWUF8QghgZjXU/MmLjKutwudOXK1bKc3Kzf+d3fgB3BgATsB8QfjY1NXyUbkwbKgraCspHwNxGYUbQpzZbLIPadjH0/ldmGDIDYif0SVI+BvqB6grkvfvwejxddbW05m5GRdpMfkID7SwLiy11lZGRoK775T2NSklEVnN7gS68KHkFIQXYGkV5WKP1wGctVr3M5RGi6Wvy4gUZLS6uz4IZfZTQ2NtpIO0IHRPnuxncH3j7pjorERAEGnaMvfNlzXBXK3dIFEsJFnw2QgwNcUYuB+cbfZjKj3WWfFMyZc/9ZMh4hAfEZ9AMHDk3IHzx4u06XEMRusfNFaHkox8Ug3Amm9tiAZGIsySAhE4CPoXz6gm/8FosVVZ06NX3MmJv3koYd1/NtYgD7UX60/Df98vJKdQkdu0r4CIsX2NAaXAzios8FCFe/hNRjc7KiMV5oAw7/XDh3rrhwROG/ibyWlwQEJERVUXFiVp/euX/j3+bD3LVwBiKEQUzUYg2kEDCEjt9mtaGLNTWPFxRcv4n0tOiAqL89UTUvOztrpYZcrhXSkwjKRBsQUFmRSkgEwxFUFZZ16+rqnxp6ff56hJADbzslAYEcu+r0qbN/ykhPf0atUQtqOBqFfomAOOwO1Hjp0oprBw/8C+n6YkDAfoDKUp8+dfbJIEBYD3awQCH6gAa7l+Wb6Rz0WYHMg6UG/8UQh9yyJY0x7mGUrC4av93hRJc6AHmFkBBPCCAn/1M5Lycn+yVWlUXvIB0XejJSQHlREkK0J4ixDPRZ6zEBSR+fgPEEVWEpb7c7UG1t3dPX/WoIqbJCAfnmm+MP9O3dZ13Qlh8xekmoVSPKCWIQQx/YAXFyuoec9IT2n40nAuvbbHb0ffXF+TfcMOwdTgk5ePDI9MHXDnorZJcJawpEDFrMZQUBIkb1kDNdDJBc9aI8fqvNhk6dPvPg6NEjtzMB4lsHAaP+2Wf7JhQMG7YNxyGRs5u/BUGARIuxkBlgsyE8QPKPRHgJi9WGKo4fn3HbbeMgMASj58tnhbi969a9PvCemTOOGQwdZwZjcYXLoFjXiyYvYE1ky9YPhs+fPxdSJ4xury8w7NGjh66q8nS10WjwJRf5UghCO8nVDhdjw60XYouJL24VISFdM35YNTQ584dc2/vy5cuwaggS4kvBh6ROEEKahoZLB5ONxgHkI/X4GB/GwlmgyWjP9C/znJyHSsOlx8UDMeOHxw1ebW39LjMzfTRCyM6UOgFgfMlFAKT6+5pNPa7pcYeQp/fwJdHYnA7ye7YZC4zluoTUY6IvpB7fBAyEObSCQoCBjQ6XL1/+pHff3Fl+QCC14NvJGJJ+B0AqT1Ytzs7J/qNapQrwu5MQX7qxo4pA789XVogKYaIP24CYNkdwSQgXvS/zQJV3XKFbXfEvkY/f6XRSdbV1fx1yXf7LBCC+7UB0QMDTUu/YsevXvx49aic9BS9s1vDJRKh2Z2dsJ4OYaHMBwn4YlX0CdAAiZiox9Yp//LCl9MuDh6dOmzblS79BBw8rBJCA65ufn2/Y9/kXZwwG31NkgmYMfatkoEsRWD8hgDBtCWWt198RegA+yKizSRb7BGDbKit2/LANqM1kto4ff+ugqqoqOOYWcHlJCYF2A5scEELamuq6f6WkJI8NnCfkY7gQ5UnqMoJBt7yfzrhRrsOG+BtmaJ+1HgmImHqEygqRlCiN393eDhsc9uf2zv4tQgiWbwMeFp09QYb9+PET83vn9n5Wo+60I4JUFp/EMqjg8duyGLeSftK3mZMka71+zZzH50XVEzRoohDP+B0OJ3WxuvrFYcOuhyc9gIcVMOhMgPg2OoAdWbp0aZ/5jy08ptNrZUEGLlIVS3dPKIRWfv14yGbre4xPoLk9XwplB0FfVD2ipZXlj6G9pi1Bm7tZ6dF7EOH4zWarZ93f1wxfvnw5nDcEHRmwH0yABOwIeFs1F2s/SElJuZn5GLTYqcNe3u6xojUnF6P/bdvuO44wKfUBVJL2AlJKuNdkYl0v0hHDMekrV64cyu2TczcRfwTtgKeHEYHN1gDIoS8P3Tvo2sGrE2K4ehjpoOO5PmR4T58+tejmX9/8Hk1d4Wc2hux6AYB8xxFAbY0bd0eP9za/XWHQ63Q/l2ftxisgcPDTZLJY7r1vdsG+fZ/A809AXYH94DyOAIAEqa1TlWeWpWeklWjUYpd0+dwStkCLLrThsji+6PtWCBubNgweMmgZm7pickKBG1hK4HyXeuHChdlPLXnmsF6vU0uDVgODBxw6fL6kCt26hwaMwd9wtxfP9OHR5WazxbFy1YpRa9asqfNLh6AjbRgk36FPyP6CLTlddWZVenr6Ayp16NsL+Oav0HnK6U4x7A8TKkfxQN/pcMH6+TvX5g+CI9E4mSjo0CcGBMckPilZunRpv0fnzd9v0Cco8fFoNiDCCEN8TUXoTQa6E2/0KS+FTGar67X168YuX778AiEdgo9FY/4EYhKQkhPHv30qJyf7UY2mI1DkS7GFAEarEFgRZUE2wFiR9VglVmQ70aLvsDup2tq6164fNnSlXzpCYg+yz2ySj22Jb9EKpKSwsDDpwx07P080GLJk8s5XDwUaiyB1wqf2BP0eh/Q97R44dVt/17Sp48vLy+GZvgAGTpVAj0PmNZcqxsbdt9YOUlJWtueOm4YPfzNBq5YElAyf7Q5XhwhCQcBTNLuNPoWsNgf11bFjDxUVTfyE5lmJfvgM3Zb44hIA5cL57zekpKRMVKt4DtlHahT4gOYDrJvpO5xOiMr39Ovft4RQVWTeilHr8zkr9LhEPX369F7r1v69LNGgz4S3p/Hx5Zf4u8fjodpM5ob5Cx4r2r59+w+EqoroAWaklJAGXv3Pf5YWTp5ctE2n1So6I/jwHczogBYf9L1eCllsNvfu3WUzfv/7YnjHCNgNuiFn9YmEzHAsJYGUCqiuo4ePluTlDXhao1H7H6QcrlUVyki+ct1PH3pgtzmoc+e+e2nEqBEbaKoKv2eE00EVCghMYrwhO2BPIGBMTU2diV3hjpkeqfKOVF66j77d7qSam5u3EgEgzldBzBG1x8QyqS4fKImJPRO++fro+uTk5Nu0mvCfpBMpBPFQ32Z3oqtXr352w40j5rW1/QjvEsFgkOsdvOGbEAnB4yVVF3aF1UOGDDHs+qhskzHRUKhW/zJBcThc8HCy8il3Fs2qrKyEdXIcb2AwyBdUcs4fsYBAY3jNJADKhAkTevzj9TfeMBgMhRqapPCFAXyzm89y0OuHa0nY+sFFH04aQBbXZDKVPzL34Yf37t2L0+p440KXPoyfNBC+11UQCUgV7FTZsf3DtT1SeoxXq5WBNyYIZWi45eiM5Atf2GagaPrw8kmHi7p85fLn06bftYDYQQJg4HUOQXZDSOqEa+LitApdUlQGwzXaI4cPLE9LTZ3RAUrnS8HYHirEeuCKT3TCzIGFSJTIHBfUh4QhbFZoam7eNnLUmKUm00949whdMhjTI3zMDWforKBAmuXwocMP9uuf96RWrZbL5P7gkcWchRy4wr1hYVTgZz7zyCcq/obE0ve0eyirw9F+4fy5V0bdPOotf24KgIgYDFIFRQsUvIaifP31NwomFxWtSdBqM1UqMDdizBVCoedjhCqVcIYSWoeJvsPpQjabvWF3WdnCuXMfrvCrJqyiwIBjmyFaMkjPKZIRkJKCo3kAxQdMUVFRyqt/Xf1SckrybSql0veSevbEfZTiBwEPu2EeMDt9eFiM0+Wirl65+tkTf1z0dFlZ2RW/RICtgJvuTfHJLyvPxU1b9pGQLjGk7EEkAtKyffvO8cMLC5/VajUZKqXCb/DDBSDcemzmn513sO3T6XJTNpu98Vh5+YvTp0/9nEUqyCg8bDAiVVlMzgF+RAeAgo83+CRmyJAh+tK3Ns3NzMp6UKVSKJUKedy+HxccDZfbjZxOt6uhvv6t4gdnvV5ZWWn2g4GlAtQTjsDj6tWrdPXne2U3LdWCJUYBmyaKi+c81Ktn6nSlUqFSKRVxA4xfIpDL5Xb+8GPz9tLSjW/6NyWASsKqCafQsVREDYxoSggdFKzCSNcYQAncs2bNSl0wf9Gc9PS0mQqFIkEhlyM500pkJBZOYN32dg+CTdAul9va1NS0de261Rs3bdoEG4sBCPqNDTcZfUekpiKNQ4QMEyt6urRg+wLA+P5/440j9cuf//OEfv3z7oRIX6GQS2VSqQSeZtdVT0QFlQTHymDdwt3u8UKkfeH8uY+WPvfC3q+/PgKqCXtMGAy6eoqqVMQCEFL6SGnBGWNsYzBA8FdWUlKSdt99D0xK65U6UqfXD5PJZFqFXEZJpFL4h2RS8u3TQuZFRxnwkmDnIOWlAACJx+OxWczm400/NB/ZvPmdjzds2NDkz8YC4zEYGATSTnSJVMQKEC41hoGhA4RTMrKsrCzVs88+N/S6oUOHJxmNg9RaTW+VUpUllUp9b/kB6fGJIf6LHWqq40gR2ANYLPJ6vU6ny1nvsNmrW1pbz5z89ttjK1a8cLKuro5Mb4A9oAMQUyCiFYcIn6adkSFdYgIg+B0BDBJ2DLDak+h0Ovm8knkZg4cOzUrU63QqjSZBrVQnqFQq3+PvnE6n1eFyWJ12u9VstZkrT5xoWL9hfaPFYsF7oGCGw40NMmY6fKbfuCy2D1GzE1xMi0YcIgYUuioj4xfS3gAodEDgMy6P+40DU7IPZJQM/8dqBjOYBASDQAeK3obYMYZdvjsAYVJlZMRPMh6DFJASAhQ6uPCZPpvJNzaTgJCzn/x/twHRHSqLbdaQkwIDQ/7FADH9xuS6k6BgBpN/SZDI73H/YqKahDAjbDGLckU2gJgkgm95gy4xcQcAnXfdqbKE4kjvI99n+gzn+yy0HzEp93MAJCaMiBci/weDVs0KUaHWZAAAAABJRU5ErkJggg==")
            no-repeat center;
        }
        #slider .drag_bg {
          height: 60px;
          width: 0px;
          border-top-left-radius: 30px;
          border-bottom-left-radius: 30px;
        }
        #slider .drag_text {
          position: absolute;
          top: 0px;
          width: 100%;
          line-height: 64px;
          font-size: 20px;
          color: rgba(81, 81, 81, 1);
          user-select: none;
          -moz-user-select: none;
          -webkit-user-select: none;
          -o-user-select: none;
          -ms-user-select: none;
        }
        .unselect {
          -moz-user-select: none;
          -webkit-user-select: none;
          -ms-user-select: none;
        }`
    )
  }

  proto.getElements = function () {
    this.slider = document.querySelector("#slider")
    this.drag_bg = document.querySelector(".drag_bg")
    this.handler = document.querySelector(".handler")
    this.drag_text = document.querySelector(".drag_text")
  }

  proto.bindEvent = function () {
    const self = this
    function start(e) {
      self.diffX = e.clientX - self.handler.offsetLeft
      util.setClassName(self.slider, "unselect")
    }

    function move(e) {
      let deltaX = e.clientX - self.diffX
      if (deltaX >= self.slider.offsetWidth - self.handler.offsetWidth) {
        deltaX = self.slider.offsetWidth - self.handler.offsetWidth
        self.flag = true
      } else if (deltaX <= 0) {
        deltaX = 0
        self.flag = false
      } else {
        self.flag = false
      }
      self.ratio = deltaX / (self.slider.offsetWidth - self.handler.offsetWidth)
      self.emit("move", self.ratio)

      util.setInlineStyle([self.handler], "left", deltaX + "px")
      util.setInlineStyle([self.drag_bg], "width", deltaX + "px")
    }

    function end() {
      util.setClassName(self.slider, "")
      self.emit("moveend", self.ratio)
      self.reset() // 将滑块复位到左侧
      document.ontouchmove && (document.ontouchmove = null)
      document.ontouchend && (document.ontouchend = null)
      document.onmousemove && (document.onmousemove = null)
      document.onmouseup && (document.onmouseup = null)
    }

    function done(result) {
      if (result) {
        util.setClassName(self.slider, "slide_ok") //验证完成后的样式
        util.addClass(self.handler, "handler_ok_bg") ////验证完成后的样式
        self.handler.onmousedown = null //防止拖动完成后再次拖动
        self.emit("complete") //emit通知使用者的回调事件
      } else {
        util.setInlineStyle([self.handler], "left", 0 + "px")
        util.setInlineStyle([self.drag_bg], "width", 0 + "px")
      }
    }

    self.handler.ontouchstart = function (e) {
      const touch = e.touches[0]
      start(touch)
      document.ontouchmove = function (e) {
        const touch = e.touches[0]
        move(touch)
      }
      document.ontouchend = function (e) {
        e.preventDefault()
        end()
      }
      self.on("done", done)
    }

    self.handler.onmousedown = function (e) {
      start(e)
      document.onmousemove = move
      document.onmouseup = end
      self.on("done", done)
    }
  }
  // 将滑块复位到左侧
  proto.reset = function () {
    const self = this
    util.setInlineStyle([self.handler], "left", 0 + "px")
    util.setInlineStyle([self.drag_bg], "width", 0 + "px")
  }

  if (typeof exports != "undefined" && !exports.nodeType) {
    if (typeof module != "undefined" && !module.nodeType && module.exports) {
      exports = module.exports = SliderTools
    }
    exports.SliderTools = SliderTools
  } else {
    root.SliderTools = SliderTools
  }
})()
